// Copyright (c) 2024 Greener Power Solutions.
// This file is part of Greener Power Solutions' software,
// and may not be altered, copied, redistributed, or sold
// without specific permission.

interface PlusIconProps {
  height?: number;
  width?: number;
  fill?: string;
}

export function PlusIcon({ height = 24, width = 24, fill = 'currentColor' }: PlusIconProps) {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" stroke={fill}>
      <path d="M12 5V19" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M5 12H19" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
